import { Checkbox, TableCell } from '@mui/material';
import RemoveIcon from '@mui/icons-material/Remove';
import { icons } from '@shared/static/icons';

export default function HeadCheckbox({
  pageSelectedCount,
  rowCount,
  onSelectAllClick,
}) {
  return (
    <TableCell padding="checkbox">
      <Checkbox
        indeterminate={pageSelectedCount > 0 && pageSelectedCount < rowCount}
        indeterminateIcon={
          <div className="custom-checkbox">
            <RemoveIcon />
          </div>
        }
        checked={rowCount > 0 && pageSelectedCount === rowCount}
        onChange={onSelectAllClick}
        icon={<div className="custom-checkbox" />}
        checkedIcon={<div className="custom-checkbox">{icons.check}</div>}
      />
    </TableCell>
  );
}
